import { withDefaults } from '@warp-drive/legacy/model/migration-support';

const ObservationDocumentSchema = withDefaults({
  type: 'observation-document',
  objectExtensions: ['observation-document'],
  fields: [
    {
      kind: 'attribute',
      name: 'discardedAt',
    },
    {
      kind: 'belongsTo',
      name: 'observation',
      type: 'observation',
      options: { async: false, inverse: null },
    },
    {
      kind: 'belongsTo',
      name: 'observableDocument',
      type: 'observable-document',
      options: { async: false, inverse: null },
    },
  ],
});

export default ObservationDocumentSchema;
